import { NavLink, Outlet } from "react-router-dom"

import { LISTS_TABS } from "@/components/layout/nav"
import { PageHeader } from "@/components/layout/page-header"
import { useActiveTabInView } from "@/components/layout/tab-strip"
import { cn } from "@/lib/utils"

/**
 * Раздел Lists (AMEND-12 §4).
 *
 * Полоса вкладок — та же, что у Scoring Engine, и по тем же причинам: на 360px
 * ряд уезжает горизонтальным скроллом внутри себя, а не ломается на две
 * строки. Заглушечные вкладки (§7) остаются **переходами**, а не серыми
 * надписями: человек должен увидеть своими глазами, что за ними ничего нет, —
 * мёртвая вкладка без перехода читалась бы как поломка.
 */
export function ListsLayout() {
  const strip = useActiveTabInView<HTMLElement>()

  return (
    <>
      <PageHeader
        title="Lists"
        tabs={
          <nav
            ref={strip}
            aria-label="Lists tabs"
            className="-mb-px flex items-end gap-1 overflow-x-auto"
          >
            {LISTS_TABS.map((tab) => (
              <NavLink
                key={tab.path}
                to={tab.path}
                // Blacklist живёт на `/lists` — без `end` он оставался бы
                // подсвеченным и на двух соседних вкладках.
                end={tab.path === "/lists"}
                className={({ isActive }) =>
                  cn(
                    "shrink-0 whitespace-nowrap border-b-2 px-2.5 pb-2 text-sm font-medium transition-colors duration-150 ease-snap",
                    isActive
                      ? "border-accent text-accent"
                      : "border-transparent text-fg-muted hover:text-fg",
                    // Вкладка без содержимого приглушена, но открывается:
                    // подпись «не реализовано» стоит за ней, а не вместо неё.
                    !tab.live && !isActive && "text-fg-subtle",
                  )
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </nav>
        }
      />
      <Outlet />
    </>
  )
}
